export default __webpack_public_path__ + "./fonts/radio-checked-black.ce3c4559.svg";